import { authApiHandler } from '../services/authApi'
import type { AuthConfig } from '../types/types'
import cookieHandler from '../handlers/cookieHandler'
import tokenHandler from '../handlers/tokenHandler'

export default (config: AuthConfig, cookieHeader?: string) => {
  const cookies = cookieHandler(cookieHeader)
  const token = tokenHandler(config)
  const authApi = authApiHandler(config)

  return async (): Promise<string | null> => {
    const accessToken = cookies.getAccessToken()

    if (token.isValidToken(accessToken)) {
      return accessToken
    }

    // Server side the middleware has already refreshed this request. In the browser no
    // access token means no session, so anonymous users never call the route.
    if (typeof window === 'undefined' || !accessToken) {
      return null
    }

    if (!(await authApi.refreshSessionViaServer()).authenticated) {
      return null
    }

    // The response has just set the renewed cookie. An httpOnly one is not readable: callers then
    // send no Authorization header and the gateway uses the cookie.
    const renewed = cookieHandler().getAccessToken()
    return token.isValidToken(renewed) ? renewed : null
  }
}
